module.exports = __webpack_public_path__ + "static/img/mu.d0663433.png";